import { colors, energyColors } from '../../types/Misc';
import { Player } from './types';

export function createPlayer(
	id: number,
	playerId: number,
	username: string,
	color: colors,
	energyColor: energyColors,
	isAdmin: boolean = false,
	isBot: boolean = false
): Player {
	return {
		id,
		playerId,
		username,
		color,
		energyColor,

		isAdmin,
		isBot,

		factories: 2,
		batteries: 0,

		factoryEnergyArr: [energyColor, energyColor],
		batteryEnergyArr: [],

		donationCup: 0,
		donationCupArr: [],

		totalDonation: 0,
		carbonReserve: 0,
		carbonFootprint: 0,

		pr: 0,
		prArr: [],

		seasonalCards: [],
		summitCards: [],

		equipment: [],

		activeContractsAndAwards: [],
		completedContracts: [],
		failedContracts: [],
		completedAwards: [],
		completedContractsAndAwards: [],

		modifiers: [],
		oneTimeModifiers: [],
		usedModifiers: [],

		effectsUsedThisSeason: [],
		cardIdPlayedThisTurn: [],

		factoriesBuiltThisSeason: 0,
		factoriesBuiltThisSeasonFromCarbonOnly: 0,
		batteriesBuiltThisSeason: 0,

		freezingPointStolenPlayerId: -1,
		neighborFactoryEnergyColorId: -1,

		resolveNextWinterSummitContractOrAward: false,
	};
}
